import { Component, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
import { projectStatusStyle } from '@dhats-hub/utils';

/**
 * Where a project stands, in one pill. Same label and same colour in the admin
 * and the client portal, so a project never reads as two different things
 * depending on who is looking.
 */
@Component({
  selector: 'dhats-project-status-pill',
  standalone: true,
  imports: [CommonModule, TranslocoPipe],
  template: `
    <span
      class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-black uppercase tracking-widest"
      [style.background]="style().bg"
      [style.color]="style().color"
      [style.border]="'1px solid ' + style().border"
    >
      <span class="w-1.5 h-1.5 rounded-full" [style.background]="style().color"></span>
      {{ 'status.' + (status() ?? '') | transloco }}
    </span>
  `,
})
export class ProjectStatusPillComponent {
  status = input<string | null | undefined>();

  readonly style = computed(() => projectStatusStyle(this.status()));
}
